module.exports = __webpack_public_path__ + "img/cub1-5_100.prt.b43e84fa.jpg";